import React from 'react';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';


function PatientsListForMerge(props) {
  const {
    classes: {
      root,
      marginLeftAuto,
      patientInfo,
      patientTitle,
      patientSubTitle,
      paper,
    },
    patientsForMerge,
    setPatientsForMerge,
    setPrimPatientId,
    setConfirmMergeDialog,
  } = props;

  const onRemovePatient = (patient) => {
    const temp = patientsForMerge.map(v=>v);
      if(patientsForMerge.length>2){
        temp.splice(patientsForMerge.indexOf(patient),1);
      }
    setPatientsForMerge(temp);
  };

   return (
    <>
      {patientsForMerge.map(patient => (
        <span  key={patient.id} className={root}>
          <Paper
            display = {'inline-block'} key={patient.id} className={paper}
            onClick={() => {setPrimPatientId(patient.id);setConfirmMergeDialog(true);}}
          >
            <span className={patientInfo}>
              <span className={patientTitle}>
                {patient.lastName}, {patient.firstName}
              </span>
              <span className={patientSubTitle}>
                ({patient.gender}, {patient.birthdate})
              </span>
            </span>
          </Paper>
          <IconButton
            className={marginLeftAuto}
            size="small"
            aria-label="Patient info"
            title="Remove patient from merge list"
            color="primary"
            onClick={()=>onRemovePatient(patient)}
          >
            <HighlightOffIcon color="primary" /> 
          </IconButton>
        </span>
      ))}
    </>
  );
}

const styles = () => ({
  root: {
    display: 'flex',
    padding: '0px 15px 15px 25px',
  },
  marginLeftAuto: {
    marginLeft: 'auto',
  },
  marginLeftTen: {
    marginLeft: 10,
  },
  patientInfo: {
    cursor: 'pointer',
  },
  patientTitle: {
    fontSize: '16px',
    lineHeight: '22px',
    fontWeight: 'normal',
    paddingRight: '5px',
  },
  patientSubTitle: {
    fontSize: '16px',
    lineHeight: '22px',
    fontWeight: 'normal',
    color: '#494949',
    textTransform: 'capitalize',
  },
  paper: {
    padding: '11px 30px',
    width: '100%',
    backgroundColor: '#E5E5E5',
    alignItems: 'center',
    cursor: 'pointer',
  },
});

export default withStyles(styles)(PatientsListForMerge);
